/*import React, { useState, useEffect } from 'react';
import './Header.css';
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { useStateValue } from './StateProvider';
import { auth, db } from './firebase';
import { collection, doc, updateDoc, query, where, getDocs, limit } from 'firebase/firestore';

function Header() {
  const [{ basket, user }] = useStateValue();
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  // Ricerca live con suggerimenti
  useEffect(() => {
    if (searchTerm.length === 0) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      const prodottiRef = collection(db, 'prodotti');
      const q = query(
        prodottiRef,
        where('title', '>=', searchTerm),
        where('title', '<=', searchTerm + '\uf8ff'),
        limit(5)
      );

      const snapshot = await getDocs(q);
      const matches = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setSuggestions(matches);
    };

    fetchSuggestions();
  }, [searchTerm]);

  // Quando si seleziona un suggerimento
  const handleSelectSuggestion = async (product) => {
    try {
      const productRef = doc(db, 'prodotti', product.id);
      await updateDoc(productRef, {
        searchCount: (product.searchCount || 0) + 1
      });
    } catch (error) {
      console.error("Errore aggiornamento searchCount:", error);
    }

    navigate(`/search?q=${product.title}`);
    setSearchTerm('');
    setSuggestions([]);
  };

  // 1. Questa è la logica di ricerca separata
  const handleSearch = () => {
    if (searchTerm.trim() === '') return;

    if (suggestions.length > 0) {
      handleSelectSuggestion(suggestions[0]);
    } else {
      navigate(`/search?q=${searchTerm}`);
      setSearchTerm('');
      setSuggestions([]);
    }
  };

  // 2. Questa intercetta il tasto Enter e richiama la funzione sopra
  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleAuthentication = () => {
    if (user) auth.signOut();
  };

  return (
    <div className='header'>
      <Link to="/"><img className="header_logo" src="/logo_quattro.png" alt='Logo'/></Link>

      <div className='header_search'>
        <input
          className='header_searchInput'
          type='text'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleEnter}
          placeholder='Cerca prodotti...'
        />
        
        <SearchIcon className='header_searchIcon' onClick={handleSearch} />

        {suggestions.length > 0 && (
          <div className="autocomplete_suggestions">
            {suggestions.map((item) => (
              <div
                key={item.id}
                className="autocomplete_item"
                onClick={() => handleSelectSuggestion(item)}
              >
                {item.title}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className='header_nav'>
        {!user && (
          <Link to="/Sign_in">
            <div className='header_option'>
              <span className='header_optionLineOne'>Ciao</span>
              <span className='header_optionLineTwo'>Registrati</span>
            </div>
          </Link>
        )}

        <Link to={!user ? "/login" : "#"}>
          <div onClick={handleAuthentication} className='header_option'>
            <span className='header_optionLineOne'>
              {user ? `Bentornato ${user.displayName}` : 'Accedi'}
            </span>
            <span className='header_optionLineTwo'>
              {user ? 'Logout' : 'Accedi'}
            </span>
          </div>
        </Link>

        <Link to='/orders'>
          <div className='header_option'>
            <span className='header_optionLineOne'>I tuoi</span>
            <span className='header_optionLineTwo'>Ordini</span>
          </div>
        </Link>

        <Link to="/checkout">
          <div className='header_optionBasket'>
            <ShoppingBasketIcon />
            <span className='header_optionLineTwo header_basketCount'>{basket?.length}</span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;*/

import React, { useState, useEffect } from 'react';
import './Header.css';
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useStateValue } from './StateProvider';
import { auth, db } from './firebase';
import { collection, doc, updateDoc, query, where, getDocs, limit } from 'firebase/firestore';

function Header() {
  const [{ basket, user }] = useStateValue();
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1); // -1 = nessuna selezione attiva
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Ricerca live con suggerimenti
  useEffect(() => {
    if (searchTerm.trim().length === 0) {
      setSuggestions([]);
      setSelectedIndex(-1);
      return;
    }

    const fetchSuggestions = async () => {
      const cleanSearchTerm = searchTerm.trim().toLowerCase();
      const prodottiRef = collection(db, 'prodotti');
      const q = query(
        prodottiRef,
        where('title_lowercase', '>=', cleanSearchTerm),
        where('title_lowercase', '<=', cleanSearchTerm + '\uf8ff'),
        limit(5)
      );

      const snapshot = await getDocs(q);
      const matches = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setSuggestions(matches);
      setSelectedIndex(-1); // Resetta la selezione quando cambiano i suggerimenti
    };

    fetchSuggestions();
  }, [searchTerm]);

  // Seleziona un suggerimento specifico (da click o invio con selezione)
  const handleSelectSuggestion = async (product) => {
    try {
      const productRef = doc(db, 'prodotti', product.id);
      await updateDoc(productRef, {
        searchCount: (product.searchCount || 0) + 1
      });
    } catch (error) {
      console.error("Errore aggiornamento searchCount:", error);
    }

    navigate(`/search?q=${encodeURIComponent(product.title)}`);
    setSearchTerm('');
    setSuggestions([]);
    setSelectedIndex(-1);
    setMenuOpen(false);
  };

  // Logica di invio ricerca
  const handleSearch = () => {
    if (searchTerm.trim() === '') return;

    // Se l'utente ha evidenziato un elemento con le frecce (selectedIndex >= 0)
    if (selectedIndex >= 0 && suggestions[selectedIndex]) {
      handleSelectSuggestion(suggestions[selectedIndex]);
    } else {
      // Altrimenti cerca la parola generica senza forzare il primo risultato
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
      setSuggestions([]);
      setSelectedIndex(-1);
      setMenuOpen(false);
    }
  };

  // Navigazione da tastiera (Frecce Su, Giù, Invio)
  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex((prevIndex) => 
        prevIndex < suggestions.length - 1 ? prevIndex + 1 : prevIndex
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : -1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleAuthentication = () => {
    if (user) auth.signOut();
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className='header'>
      <div className='header_top_mobile'>
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img className="header_logo" src="/logo_quattro.png" alt='Logo'/>
        </Link>

        <div className="header_hamburger" onClick={toggleMenu}>
          {menuOpen ? <CloseIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
        </div>
      </div>

      <div className='header_search'>
        <input
          className='header_searchInput'
          type='text'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder='Cerca prodotti...'
        />
        
        <SearchIcon className='header_searchIcon' onClick={handleSearch} />

        {suggestions.length > 0 && (
          <div className="autocomplete_suggestions">
            {suggestions.map((item, index) => (
              <div
                key={item.id}
                className={`autocomplete_item ${index === selectedIndex ? 'selected' : ''}`}
                onClick={() => handleSelectSuggestion(item)}
                onMouseEnter={() => setSelectedIndex(index)}
              >
                {item.title}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={`header_nav ${menuOpen ? 'header_nav_open' : ''}`}>
        {!user && (
          <Link to="/Sign_in" onClick={() => setMenuOpen(false)}>
            <div className='header_option'>
              <span className='header_optionLineOne'>Ciao</span>
              <span className='header_optionLineTwo'>Registrati</span>
            </div>
          </Link>
        )}

        <Link to={!user ? "/login" : "#"} onClick={() => setMenuOpen(false)}>
          <div onClick={handleAuthentication} className='header_option'>
            <span className='header_optionLineOne'>
              {user ? `Bentornato ${user.displayName}` : 'Accedi'}
            </span>
            <span className='header_optionLineTwo'>
              {user ? 'Logout' : 'Accedi'}
            </span>
          </div>
        </Link>

        <Link to='/orders' onClick={() => setMenuOpen(false)}>
          <div className='header_option'>
            <span className='header_optionLineOne'>I tuoi</span>
            <span className='header_optionLineTwo'>Ordini</span>
          </div>
        </Link>

        <Link to="/checkout" onClick={() => setMenuOpen(false)}>
          <div className='header_optionBasket'>
            <ShoppingBasketIcon />
            <span className='header_optionLineTwo header_basketCount'>{basket?.length}</span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;